import React, {Component} from 'react'

import { EditorState, ContentState, convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

class RichTextarea extends Component {
  constructor(props) {
    super(props);

    let editorState;

    if (props.field.value) {
      const blocksFromHtml = htmlToDraft(props.field.value);
			const { contentBlocks, entityMap } = blocksFromHtml;
			const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
			editorState = EditorState.createWithContent(contentState);
    }
    else {
      editorState = EditorState.createEmpty();
    }

    this.state = { editorState };

    this.onEditorStateChange = this.onEditorStateChange.bind(this);
  }

  onEditorStateChange(editorState) {
    this.setState({editorState});
    let content = draftToHtml(convertToRaw(editorState.getCurrentContent()))
    this.props.validate(content, this.props.field);
  }

  render() {
    let field = this.props.field;
    let hasErrors = field.errors.length > 0 ? true : false
    
    return (
      <div className={hasErrors ? 'form-group text-danger' : 'form-group'}>
        <label className="form-control-label">{field.rules.title}</label>
        <div>
          <Editor
            editorState={this.state.editorState }
            editorStyle={{fontFamily: 'Gilroy', fontSize: '16px'}}
            wrapperStyle={{border: '1px solid #F1F1F1', borderRadius: '2px', paddingLeft: '5px', paddingRight: '5px'}}
            toolbarStyle={{borderTop: '0', borderLeft: '0', borderRight: '0'}}
            onEditorStateChange={this.onEditorStateChange}
            toolbar={{
              options: ['inline', 'blockType', 'fontSize', 'fontFamily', 'list', 'textAlign', 'colorPicker', 'link', 'remove', 'history'],
              inline: {
                options: ['bold', 'italic', 'underline', 'strikethrough']
              },
              fontFamily: {
                options: ['Gilroy']
              }
            }}
          />
        </div>

        {field.errors.map((error, i) => (
          <div key={i} className="form-text text-danger">
            {error}
          </div>
        ))}
      </div>
    )
  }
}

export default (RichTextarea)
